import React, { useState } from 'react';
import { Table, Button, Icon, Input } from 'antd';
import Highlighter from 'react-highlight-words';
import { Link, withRouter } from 'react-router-dom';

import './ListSuppliers.scss';

function ListSuppliers(props) {
	const { suppliers, setReloadSuppliers, reloadSuppliers } = props;
	const [searchText, setSearchText] = useState('');
	const [searchedColumn, setSearchedColumn] = useState('');

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				<Input
					placeholder={`Buscar ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
					icon="search"
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>
					Buscar
				</Button>
				<Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
					Limpiar
				</Button>
			</div>
		),
		filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
		onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
		render: (text) =>
			searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text.toString()}
				/>
			) : (
				text
			),
	});

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText('');
	};

	const columns = [
		{
			title: 'NIT',
			width: 150,
			dataIndex: 'nit',
			key: 'nit',
			fixed: 'left',
			...getColumnSearchProps('nit'),
		},
		{
			title: 'Nombre',
			width: 300,
			dataIndex: 'nombre',
			key: 'nombre',
			fixed: 'left',
			...getColumnSearchProps('nombre'),
		},
		{
			title: 'Dirección',
			dataIndex: 'direccion',
			key: 'direccion',
		},
		{
			title: 'Teléfono',
			dataIndex: 'telefono',
			key: 'telefono',
		},
		{
			title: 'Ciudad',
			dataIndex: 'ciudad',
			key: 'ciudad',
		},
		{
			title: 'Correo Electrónico',
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: 'Opciones',
			key: 'operation',
			fixed: 'right',
			width: 100,
			render: (text, record) => (
				<Button type="primary">
					<Link to={`/proveedor/certificados/${record.nit}`} title={'Ver detalle certificado'}>
						<Icon type="folder-open" />
					</Link>
				</Button>
			),
		},
	];

	return (
		<div className="list-suppliers">
			<Table columns={columns} dataSource={suppliers} scroll={{ x: 1500 }} sticky loading={reloadSuppliers} />
		</div>
	);
}

export default withRouter(ListSuppliers);
